import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fee1ce64"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-17 ant-col-xl-17" }, null, -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_4 = {
  key: 0,
  class: "ss-movimento-comercial-cabecalho-fixo"
}
const _hoisted_5 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_6 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-movimento-comercial-campo-totalizador",
  style: {"padding":"10px 10px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Etapa", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-1 ss-movimento-comercial-campo-totalizador" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Itens", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Produtos", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Serviços", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descontos", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Frete", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Seguro", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Outras Despesas", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-movimento-comercial-campo-totalizador",
  style: {"background-color":"#000066"}
}
const _hoisted_34 = { style: {"color":"white"} }
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sim", -1))
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_39 = { class: "ant-input-group-wrapper" }
const _hoisted_40 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_41 = {
  class: "ant-input-group-addon",
  style: {"padding":"0px","background-color":"transparent","border":"none!important"}
}
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_44 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"inline-block","font-weight":"500","margin-bottom":"4px"} }, [
  /*#__PURE__*/_createTextVNode("Tipo de Operação"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1))
const _hoisted_47 = { class: "ant-row" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"inline-block","font-weight":"500","margin-bottom":"4px"} }, [
  /*#__PURE__*/_createTextVNode("Cliente"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1))
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"inline-block","font-weight":"500","margin-bottom":"4px"} }, [
  /*#__PURE__*/_createTextVNode("Vendedor"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1))
const _hoisted_53 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"inline-block","font-weight":"500","margin-bottom":"4px"} }, [
  /*#__PURE__*/_createTextVNode("Forma de Pagamento"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1))
const _hoisted_55 = { class: "ant-row" }
const _hoisted_56 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_57 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Documento Fiscal"
}, "Documento Fiscal", -1))
const _hoisted_59 = { class: "ant-row" }
const _hoisted_60 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_61 = { class: "ant-row" }
const _hoisted_62 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_63 = { class: "ant-row" }
const _hoisted_64 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_65 = { class: "ant-row" }
const _hoisted_66 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_67 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_70 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_71 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_72 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_73 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_status_venda = _resolveComponent("selecionar-status-venda")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_selecionar_tipo_operacao = _resolveComponent("selecionar-tipo-operacao")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_colaborador = _resolveComponent("selecionar-colaborador")!
  const _component_selecionar_forma_pagamento = _resolveComponent("selecionar-forma-pagamento")!
  const _component_selecionar_marcador_nota_fiscal = _resolveComponent("selecionar-marcador-nota-fiscal")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_card = _resolveComponent("card")!
  const _component_barra_progresso = _resolveComponent("barra-progresso")!
  const _component_venda_itens = _resolveComponent("venda-itens")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_nota_fiscal_servico_itens = _resolveComponent("nota-fiscal-servico-itens")!
  const _component_nota_fiscal_impostos = _resolveComponent("nota-fiscal-impostos")!
  const _component_nota_fiscal_frete = _resolveComponent("nota-fiscal-frete")!
  const _component_nota_fiscal_descontos_acrescimos = _resolveComponent("nota-fiscal-descontos-acrescimos")!
  const _component_venda_detalhes_pagamento = _resolveComponent("venda-detalhes-pagamento")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_VendaOrdensProducaoVinculadasTab = _resolveComponent("VendaOrdensProducaoVinculadasTab")!
  const _component_venda_comissao = _resolveComponent("venda-comissao")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_nota_fiscal_anexos = _resolveComponent("nota-fiscal-anexos")!
  const _component_nota_fiscal_historico = _resolveComponent("nota-fiscal-historico")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_requisitar_autorizacao_modal = _resolveComponent("requisitar-autorizacao-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    maskClosable: false,
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile ? 'full-modal ss-modal-vendas' : _ctx.state.venda.codigo === 0 ? 'ss-modal-vendas' : 'scroll-modal ss-modal-vendas'
  }, {
    title: _withCtx(() => [
      _createTextVNode("Venda")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      ((!_ctx.modalBase.apresentarBarraProgresso || !_ctx.state.incluindoCabecalhoVenda))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              ((_ctx.state.venda.codigo > 0 && !_ctx.state.telaMobile))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!_ctx.etapa.ultimaEtapa)
                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 0,
                          placement: "top",
                          title: "Concluir Etapa"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.concluirEtapa && _ctx.concluirEtapa(...args)))
                            }, [
                              _createVNode(_component_icone, { nome: "check" })
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.etapa.primeiraEtapa)
                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 1,
                          placement: "top",
                          title: "Retornar Etapa"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.retornarEtapa && _ctx.retornarEtapa(...args)))
                            }, [
                              _createVNode(_component_icone, { nome: "rollback" })
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.servicoVendas.verificaSePodeExcluir(_ctx.state.venda.status))
                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 2,
                          placement: "top",
                          title: "Excluir"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
                            }, [
                              _createVNode(_component_icone, { nome: "excluir" })
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Imprimir"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
                        }, [
                          _createVNode(_component_icone, { nome: "imprimir" })
                        ])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.state.venda.notaFiscal.status === _ctx.EStatusNotaFiscal.Autorizada)
                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                    key: 1,
                    placement: "top",
                    title: "Imprimir NF-e"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.visualizarDFe && _ctx.visualizarDFe(...args)))
                      }, [
                        _createVNode(_component_icone, { nome: "nfe" })
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_button, {
                type: "primary",
                size: "large",
                class: "ss-btn-acao-destaque",
                loading: _ctx.state.carregando || _ctx.state.carregandoItens,
                onClick: _ctx.salvar
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.state.venda.codigo > 0 ? 'Salvar' : 'Continuar'), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 10 }
      }, {
        default: _withCtx(() => [
          ((_ctx.state.venda.codigo > 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      style: _normalizeStyle('color: white; font-size: 11px; background-color: ' + _ctx.etapa.cor + '!important;'),
                      value: _ctx.etapa.nome,
                      disabled: "true"
                    }, null, 12, _hoisted_8)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.state.venda.itens.length,
                      disabled: "true"
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.venda.notaFiscal.totalProdutos, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_14)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.venda.totalServicos, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_17)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.venda.notaFiscal.totalDesconto, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_20)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.venda.notaFiscal.totalFrete, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_23)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.venda.notaFiscal.totalSeguro, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_26)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.venda.notaFiscal.totalOutrasDespesas, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_29)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.valorTotalImpostos, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_32)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_a_popover, {
                      placement: "top",
                      title: "Incidência no Total da Venda"
                    }, {
                      content: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.incidenciasCalculo, (incidencia, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: incidencia.incidencia + index
                          }, [
                            (incidencia.incidencia === 'TotalNota')
                              ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                  key: 0,
                                  style: {"margin-left":"0px!important"},
                                  checked: incidencia.valor,
                                  "onUpdate:checked": ($event: any) => ((incidencia.valor) = $event),
                                  onChange: _ctx.atualizarValoresTotais
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.obtemDescricaoIncidencia(incidencia.identificador)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["checked", "onUpdate:checked", "onChange"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_34, [
                          _createTextVNode("Total da Venda "),
                          _createVNode(_component_icone, {
                            class: "ss-icone-informacao-campo",
                            nome: "informacoes-fp"
                          })
                        ]),
                        _createElementVNode("input", {
                          type: "text",
                          class: "ant-input hidden ss-movimento-input-totalizador",
                          style: {"background-color":"#000066","color":"white","font-weight":"900","font-size":"20px"},
                          value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.venda.notaFiscal.totalNotaFiscal + _ctx.state.venda.totalServicos, 2, true),
                          disabled: "true"
                        }, null, 8, _hoisted_35)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.state.cacheDisponivel && _ctx.state.editavel)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      type: "warning",
                      "show-icon": "",
                      closable: ""
                    }, {
                      message: _withCtx(() => [
                        _createTextVNode(" Você possui uma versão mais recente desta venda salvo de forma automática, deseja recuperar? "),
                        _createVNode(_component_a_button, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.recuperarCacheRegistro())),
                          size: "small",
                          type: "text"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_36
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, [
                        _createElementVNode("span", _hoisted_40, [
                          _createElementVNode("span", _hoisted_41, [
                            _createVNode(_component_icone, {
                              class: "ss-icone",
                              style: 'color: #a0aec1;padding: 8px;background-color: #ebeff2;border-radius: 3px;',
                              nome: "numero"
                            })
                          ]),
                          _createVNode(_component_a_form_item, {
                            label: "Número",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.venda.numero, 0, false),
                                disabled: "true"
                              }, null, 8, _hoisted_42)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_a_form_item, {
                        label: "Status",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_status_venda, {
                            valor: _ctx.state.venda.status,
                            "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.venda.status) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_a_form_item, {
                        label: "Data da Venda",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            horaMinuto: true,
                            dataSelecionada: _ctx.state.venda.dataVenda,
                            "onUpdate:dataSelecionada": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.venda.dataVenda) = $event)),
                            disabled: !_ctx.state.editavel,
                            onChange: _ctx.salvarCacheRegistro
                          }, null, 8, ["dataSelecionada", "disabled", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_a_form_item, { rules: [{ required: true }] }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, {
                            align: "middle",
                            gutter: "8"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xs: 3,
                                sm: 3,
                                md: 5,
                                lg: 2,
                                style: {"display":"flex","justify-content":"left","margin-top":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_icone, {
                                    class: "ss-icone",
                                    style: 'color: #a0aec1; padding: 5px; background-color: #ebeff2; border-radius: 0px;',
                                    nome: "dinheiro"
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 21,
                                sm: 21,
                                md: 22,
                                lg: 22
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_46,
                                  _createVNode(_component_selecionar_tipo_operacao, {
                                    codigoSelecionado: _ctx.state.venda.codigoTipoOperacao,
                                    "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.venda.codigoTipoOperacao) = $event)),
                                    empresas: [_ctx.state.venda.codigoEmpresa],
                                    limparSelecao: false,
                                    tipoMovimento: _ctx.ETipoMovimentoComercial.Vendas,
                                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.preencherTipoOperacao(true))),
                                    classCss: " ss-venda-dados-principais",
                                    disabled: !_ctx.state.editavel,
                                    required: true,
                                    onKeydown: _cache[10] || (_cache[10] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"]))
                                  }, null, 8, ["codigoSelecionado", "empresas", "tipoMovimento", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      (_ctx.state.statusBloqueioCliente)
                        ? (_openBlock(), _createBlock(_component_a_alert, {
                            key: 0,
                            type: _ctx.state.tipoInfoBloqueioCliente,
                            style: {"width":"100%","margin":"3px"},
                            "show-icon": ""
                          }, {
                            message: _withCtx(() => [
                              _createTextVNode("Cliente com bloqueio de movimentação!")
                            ]),
                            _: 1
                          }, 8, ["type"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_a_form_item, { rules: [{ required: true }] }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, {
                            align: "middle",
                            gutter: "8"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xs: 3,
                                sm: 3,
                                md: 1,
                                lg: 1,
                                style: {"display":"flex","justify-content":"center","margin-top":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_icone, {
                                    class: "ss-icone",
                                    style: 'color: #a0aec1; padding: 8px; background-color: #ebeff2; border-radius: 3px;',
                                    nome: "cliente"
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 21,
                                sm: 21,
                                md: 23,
                                lg: 23
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_50,
                                  _createVNode(_component_selecionar_pessoa, {
                                    classCss: "ss-venda-dados-principais",
                                    style: {"width":"99%","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"},
                                    codigoSelecionado: _ctx.state.venda.notaFiscal.destinatario.codigoPessoa,
                                    "onUpdate:codigoSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.venda.notaFiscal.destinatario.codigoPessoa) = $event)),
                                    recursoOrigem: "VENDAS",
                                    empresas: [_ctx.state.venda.codigoEmpresa],
                                    preencherCodigoRelacao: true,
                                    codigoRelacao: _ctx.state.venda.codigoCliente,
                                    "onUpdate:codigoRelacao": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.venda.codigoCliente) = $event)),
                                    disabled: !_ctx.state.editavel,
                                    apresentarRelacoes: false,
                                    tipoRelacao: _ctx.ETipoRelacaoPessoa.Cliente,
                                    limparSelecao: false,
                                    onChange: _ctx.atualizarInformacoesPessoa,
                                    onKeydown: [
                                      _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                      _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                      _cache[15] || (_cache[15] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                                    ]
                                  }, null, 8, ["codigoSelecionado", "empresas", "codigoRelacao", "disabled", "tipoRelacao", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_a_form_item, { rules: [{ required: true }] }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, {
                            align: "middle",
                            gutter: "8"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xs: 3,
                                sm: 3,
                                md: 5,
                                lg: 2,
                                style: {"display":"flex","justify-content":"left","margin-top":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_icone, {
                                    class: "ss-icone",
                                    style: 'color: #a0aec1; padding: 5px; background-color: #ebeff2; border-radius: 0px;',
                                    nome: "usuario"
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 21,
                                sm: 21,
                                md: 22,
                                lg: 22
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_52,
                                  _createVNode(_component_selecionar_colaborador, {
                                    codigoSelecionado: _ctx.state.venda.codigoVendedor,
                                    "onUpdate:codigoSelecionado": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.venda.codigoVendedor) = $event)),
                                    disabled: !_ctx.state.editavel,
                                    classCss: "ss-venda-dados-principais",
                                    limparSelecao: false,
                                    empresas: [_ctx.state.venda.codigoEmpresa],
                                    onChange: _ctx.atualizarInformacoesColaborador,
                                    onKeydown: [
                                      _cache[17] || (_cache[17] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                      _cache[18] || (_cache[18] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                      _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"]))
                                    ]
                                  }, null, 8, ["codigoSelecionado", "disabled", "empresas", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_a_form_item, { rules: [{ required: true }] }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, {
                            align: "middle",
                            gutter: "8"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xs: 3,
                                sm: 3,
                                md: 5,
                                lg: 2,
                                style: {"display":"flex","justify-content":"left","margin-top":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_icone, {
                                    class: "ss-icone",
                                    style: 'color: #a0aec1; padding: 5px; background-color: #ebeff2; border-radius: 0px;',
                                    nome: "dinheiro"
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 21,
                                sm: 21,
                                md: 22,
                                lg: 22
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_54,
                                  _createVNode(_component_selecionar_forma_pagamento, {
                                    apresentacaoPersonalizada: false,
                                    codigoSelecionado: _ctx.state.venda.codigoFormaPagamento,
                                    "onUpdate:codigoSelecionado": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.venda.codigoFormaPagamento) = $event)),
                                    empresas: [_ctx.state.venda.codigoEmpresa],
                                    classCss: " ss-venda-dados-principais",
                                    disabled: !_ctx.state.editavel,
                                    required: true,
                                    tipoMovimento: _ctx.ETipoMovimentoComercial.Vendas,
                                    limparSelecao: false,
                                    onChange: _ctx.obterFormaPagamento,
                                    onKeydown: _cache[21] || (_cache[21] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"]))
                                  }, null, 8, ["codigoSelecionado", "empresas", "disabled", "tipoMovimento", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_a_form_item, {
                        label: "Marcadores",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_marcador_nota_fiscal, {
                            marcadoresSelecionados: _ctx.state.marcadores,
                            "onUpdate:marcadoresSelecionados": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                            onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.salvarCacheRegistro())),
                            disabled: !_ctx.state.editavel
                          }, null, 8, ["marcadoresSelecionados", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                        label: _withCtx(() => [
                          _hoisted_58,
                          (_ctx.state.permitirNfe && _ctx.state.permitirNfce)
                            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                key: 0,
                                placement: "top",
                                title: "Escolha o Documento fiscal eletrônico que deseja gerar no Faturamento."
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_icone, {
                                    class: "ss-icone-informacao-campo",
                                    nome: "informacao-campo"
                                  })
                                ]),
                                _: 1
                              }))
                            : (_ctx.state.permitirNfe)
                              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                  key: 1,
                                  placement: "top",
                                  title: "É permitido apenas NF-e para esse cliente"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_icone, {
                                      class: "ss-icone-informacao-campo",
                                      nome: "informacao-campo"
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.state.permitirNfce)
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 2,
                                    placement: "top",
                                    title: "É permitido apenas NFC-e para esse cliente"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_icone, {
                                        class: "ss-icone-informacao-campo",
                                        nome: "informacao-campo"
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio_group, {
                            disabled: !_ctx.state.editavel,
                            value: _ctx.state.venda.notaFiscal.modelo,
                            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.venda.notaFiscal.modelo) = $event)),
                            "button-style": "solid"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.state.permitirNfe)
                                ? (_openBlock(), _createBlock(_component_a_radio_button, {
                                    key: 0,
                                    value: "55"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("NF-e")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.state.permitirNfce)
                                ? (_openBlock(), _createBlock(_component_a_radio_button, {
                                    key: 1,
                                    value: "65"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("NFC-e")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["disabled", "value"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_card, { titulo: " " }, {
                default: _withCtx(() => [
                  ((_ctx.state.venda.codigo === 0 && _ctx.state.incluindoCabecalhoVenda))
                    ? (_openBlock(), _createBlock(_component_barra_progresso, {
                        key: 0,
                        visivel: _ctx.state.incluindoCabecalhoVenda,
                        frase: 'Aguarde por favor... Estamos buscando as regras, tributações e informações para sua venda ocorrer corretamente.'
                      }, null, 8, ["visivel", "frase"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.venda.codigo > 0)
                    ? (_openBlock(), _createBlock(_component_a_tabs, {
                        key: 1,
                        activeKey: _ctx.state.abaAtiva,
                        "onUpdate:activeKey": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.state.abaAtiva) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tab_pane, {
                            key: "1",
                            tab: "PRODUTOS"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_venda_itens, {
                                tipoOperacao: _ctx.state.tipoOperacao,
                                dadosPessoaMovimento: _ctx.state.dadosPessoaMovimento,
                                key: _ctx.state.chaveItens,
                                "tabelas-precos": _ctx.state.tabelasPrecosDisponiveis,
                                totalVenda: _ctx.state.venda.notaFiscal.totalNotaFiscal,
                                incidencias: _ctx.state.venda.notaFiscal.incidenciasCalculo,
                                itens: _ctx.state.venda.itens,
                                "onUpdate:itens": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.venda.itens) = $event)),
                                editavel: _ctx.state.editavel,
                                buscarDadosFiscaisRecalcular: _ctx.state.buscarDadosFiscaisRecalcular,
                                "onUpdate:buscarDadosFiscaisRecalcular": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.buscarDadosFiscaisRecalcular) = $event)),
                                adicionarPrimeiroItem: _ctx.state.adicionarPrimeiroItem,
                                atualizarValores: _ctx.state.venda.atualizarValores,
                                dadosAdicionais: _ctx.state.venda.notaFiscal.dadosAdicionais,
                                "onUpdate:dadosAdicionais": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.venda.notaFiscal.dadosAdicionais) = $event)),
                                onItemAlterado: _ctx.atualizarValoresTotais,
                                carregando: _ctx.state.carregandoItens
                              }, null, 8, ["tipoOperacao", "dadosPessoaMovimento", "tabelas-precos", "totalVenda", "incidencias", "itens", "editavel", "buscarDadosFiscaisRecalcular", "adicionarPrimeiroItem", "atualizarValores", "dadosAdicionais", "onItemAlterado", "carregando"]))
                            ]),
                            _: 1
                          }),
                          (_ctx.permissaoServico)
                            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: "2",
                                tab: "SERVIÇOS"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_alert, {
                                    style: {"margin-top":"5px"},
                                    description: "Devido a limitação de um item por nota no momento da emissão, será gerada uma NFS-e para cada serviço inserido aqui.",
                                    type: "info",
                                    "show-icon": ""
                                  }),
                                  _createVNode(_component_nota_fiscal_servico_itens, {
                                    regimeTributario: _ctx.state.regimeTributario,
                                    empresa: _ctx.state.venda.codigoEmpresa,
                                    "obrigar-principal": false,
                                    editavel: _ctx.state.editavel,
                                    itens: _ctx.state.servicos,
                                    "onUpdate:itens": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.servicos) = $event)),
                                    onExcluirItem: _ctx.excluirServico,
                                    onAtualizarValores: _ctx.atualizarValoresTotais
                                  }, null, 8, ["regimeTributario", "empresa", "editavel", "itens", "onExcluirItem", "onAtualizarValores"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_tab_pane, {
                            key: "3",
                            tab: "IMPOSTOS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_impostos, {
                                impostos: _ctx.state.venda.notaFiscal.totalImpostos,
                                "onUpdate:impostos": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.venda.notaFiscal.totalImpostos) = $event)),
                                incidenciasCalculo: _ctx.state.incidenciasCalculo,
                                "onUpdate:incidenciasCalculo": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.incidenciasCalculo) = $event)),
                                onTotalAlterado: _ctx.atualizarValoresTotais,
                                editavel: false
                              }, null, 8, ["impostos", "incidenciasCalculo", "onTotalAlterado"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "4",
                            tab: "FRETE"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_frete, {
                                notaFiscal: _ctx.state.venda.notaFiscal,
                                "onUpdate:notaFiscal": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.venda.notaFiscal) = $event)),
                                editavel: _ctx.state.venda.notaFiscal.status < _ctx.EStatusNotaFiscal.Autorizada,
                                mostrarOutrosValores: false,
                                onTotalAlterado: _ctx.atualizarValoresTotais,
                                selecaoManualTipoFrete: _ctx.state.tipoFreteManual,
                                "onUpdate:selecaoManualTipoFrete": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.tipoFreteManual) = $event))
                              }, null, 8, ["notaFiscal", "editavel", "onTotalAlterado", "selecaoManualTipoFrete"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "5",
                            tab: "DESCONTOS E ACRÉSCIMOS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_descontos_acrescimos, {
                                notaFiscal: _ctx.state.venda.notaFiscal,
                                "onUpdate:notaFiscal": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.venda.notaFiscal) = $event)),
                                editavel: _ctx.state.editavel,
                                onTotalAlterado: _ctx.atualizarValoresTotais,
                                onPercentualDescontoAlterado: _cache[34] || (_cache[34] = ($event: any) => (_ctx.aplicarDescontoGlobal('PORCENTAGEM'))),
                                onDescontoAlterado: _cache[35] || (_cache[35] = ($event: any) => (_ctx.aplicarDescontoGlobal('VALOR')))
                              }, null, 8, ["notaFiscal", "editavel", "onTotalAlterado"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "6",
                            tab: "DETALHES DO PAGAMENTO"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_spin, {
                                spinning: _ctx.state.carregando
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_venda_detalhes_pagamento, {
                                    "tipos-documentos": _ctx.state.dadosPessoaMovimento.tiposDocumentos,
                                    venda: _ctx.state.venda,
                                    "onUpdate:venda": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.venda) = $event)),
                                    totalCaixa: _ctx.state.totalCaixaLancado,
                                    "onUpdate:totalCaixa": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.totalCaixaLancado) = $event)),
                                    totalCarteira: _ctx.state.totalCarteiraLancado,
                                    "onUpdate:totalCarteira": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.totalCarteiraLancado) = $event)),
                                    totalOutros: _ctx.state.totalOutrosLancado,
                                    "onUpdate:totalOutros": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.totalOutrosLancado) = $event)),
                                    editavel: _ctx.state.editavel,
                                    onAdicionarTaxas: _ctx.adicionarTaxasPagamento,
                                    onRemoverTaxas: _ctx.removerTaxasPagamento
                                  }, null, 8, ["tipos-documentos", "venda", "totalCaixa", "totalCarteira", "totalOutros", "editavel", "onAdicionarTaxas", "onRemoverTaxas"])
                                ]),
                                _: 1
                              }, 8, ["spinning"])
                            ]),
                            _: 1
                          }),
                          (_ctx.possuiOrdensProducaoVinculadas)
                            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: "ordensProducao",
                                tab: "ORDENS DE PRODUÇÃO"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_spin, {
                                    spinning: _ctx.state.carregando
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_VendaOrdensProducaoVinculadasTab, {
                                        itens: _ctx.state.venda.itens
                                      }, null, 8, ["itens"])
                                    ]),
                                    _: 1
                                  }, 8, ["spinning"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.UtilitarioGeral.objetoValido(_ctx.state.tipoOperacao) && _ctx.state.tipoOperacao.gerarComissao)
                            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: "10",
                                tab: "COMISSÃO"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_spin, {
                                    spinning: _ctx.state.carregando
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_venda_comissao, {
                                        empresas: [_ctx.state.venda.codigoEmpresa],
                                        editar: _ctx.state.editarComissao,
                                        valorVenda: _ctx.state.venda.notaFiscal.totalProdutos,
                                        comissoes: _ctx.state.venda.comissoes,
                                        "onUpdate:comissoes": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.state.venda.comissoes) = $event)),
                                        onRecalcularComissao: _ctx.calcularComissoes
                                      }, null, 8, ["empresas", "editar", "valorVenda", "comissoes", "onRecalcularComissao"])
                                    ]),
                                    _: 1
                                  }, 8, ["spinning"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_tab_pane, {
                            key: "7",
                            tab: "OBSERVAÇÕES"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("div", _hoisted_60, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Observações do Cliente",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_editor_html, {
                                        value: _ctx.state.venda.observacoesCliente,
                                        "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.venda.observacoesCliente) = $event)),
                                        onChange: _ctx.salvarCacheRegistro,
                                        disabled: !(_ctx.state.venda.status !== _ctx.EStatusVenda.Cancelada)
                                      }, null, 8, ["value", "onChange", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("div", _hoisted_62, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Observações de Entrega",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_editor_html, {
                                        value: _ctx.state.venda.observacoesEntrega,
                                        "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.venda.observacoesEntrega) = $event)),
                                        onChange: _ctx.salvarCacheRegistro,
                                        disabled: !(_ctx.state.venda.status !== _ctx.EStatusVenda.Cancelada)
                                      }, null, 8, ["value", "onChange", "disabled"]),
                                      _createTextVNode(" /> ")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Dados Adicionais",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_editor_html, {
                                        value: _ctx.state.venda.notaFiscal.dadosAdicionais,
                                        "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.state.venda.notaFiscal.dadosAdicionais) = $event)),
                                        onChange: _ctx.salvarCacheRegistro,
                                        disabled: !(_ctx.state.venda.notaFiscal.numeroNotaFiscal === 0)
                                      }, null, 8, ["value", "onChange", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "8",
                            tab: "ANEXOS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_spin, {
                                spinning: _ctx.state.carregando
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_nota_fiscal_anexos, {
                                    codigoRegistro: _ctx.state.venda.notaFiscal.codigo,
                                    empresa: _ctx.state.venda.codigoEmpresa,
                                    editavel: _ctx.state.editavel,
                                    anexos: _ctx.state.venda.notaFiscal.anexos,
                                    "onUpdate:anexos": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.state.venda.notaFiscal.anexos) = $event)),
                                    onAtualizarAnexo: _ctx.atualizarAnexo,
                                    onExcluirAnexo: _ctx.excluirAnexo
                                  }, null, 8, ["codigoRegistro", "empresa", "editavel", "anexos", "onAtualizarAnexo", "onExcluirAnexo"])
                                ]),
                                _: 1
                              }, 8, ["spinning"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "9",
                            tab: "HISTÓRICO"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_spin, {
                                spinning: _ctx.state.carregando
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_nota_fiscal_historico, {
                                    registros: _ctx.state.registrosAtividade
                                  }, null, 8, ["registros"])
                                ]),
                                _: 1
                              }, 8, ["spinning"])
                            ]),
                            _: 1
                          }),
                          (_ctx.state.venda.notaFiscal.numeroNotaFiscal > 0)
                            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: 3,
                                Key: "10",
                                tab: "DOCUMENTO FISCAL"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("div", _hoisted_66, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Número da NF",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_67, [
                                            _createElementVNode("input", {
                                              type: "text",
                                              class: "ant-input ss-venda-dados-principais",
                                              style: {"flex":"1"},
                                              value: _ctx.state.venda.notaFiscal.numeroNotaFiscal,
                                              disabled: ""
                                            }, null, 8, _hoisted_68)
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_69, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Data de Emissão",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_70, [
                                            _createVNode(_component_selecionar_data, {
                                              horaMinuto: true,
                                              dataSelecionada: _ctx.state.venda.notaFiscal.dataEmissao,
                                              "onUpdate:dataSelecionada": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.state.venda.notaFiscal.dataEmissao) = $event)),
                                              disabled: true
                                            }, null, 8, ["dataSelecionada"])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_71, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Chave de Acesso",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_72, [
                                            _createElementVNode("input", {
                                              type: "text",
                                              class: "ant-input",
                                              value: _ctx.state.venda.notaFiscal.chaveAcesso,
                                              disabled: "",
                                              style: {"flex":"1"}
                                            }, null, 8, _hoisted_73),
                                            _createElementVNode("a", {
                                              class: "visualizar",
                                              onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.copiarChave && _ctx.copiarChave(...args))),
                                              style: {"margin-left":"8px"}
                                            }, [
                                              _createVNode(_component_icone, { nome: "copiar" })
                                            ])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["activeKey"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
      _createVNode(_component_requisitar_autorizacao_modal, {
        visivel: _ctx.requisicaoAutorizacaoBase.exibirRequisicao,
        "onUpdate:visivel": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.requisicaoAutorizacaoBase.exibirRequisicao) = $event)),
        "identificador-permissao": _ctx.requisicaoAutorizacaoBase.permissao,
        descricao: _ctx.requisicaoAutorizacaoBase.descricao,
        onAutorizada: _cache[50] || (_cache[50] = ($event: any) => {_ctx.buscarItensDadosAtualizados(false);}),
        onNegada: _cache[51] || (_cache[51] = ($event: any) => {_ctx.buscarItensDadosAtualizados(true);})
      }, null, 8, ["visivel", "identificador-permissao", "descricao"]),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}